import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import { useSolutionsAdvantageContent } from '../../../../hooks/useSolutionsAdvantageContent';
import './Advantage.css';

const Advantage = () => {
  const { content, isLoading } = useSolutionsAdvantageContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, eagle } = content;

  return (
    <section className="advantage">
      <div className="advantage__inner">
        <div className="advantage__panel">
          <Reveal className="advantage__content">
            <img
              className="advantage__eagle"
              src={eagle}
              alt=""
              aria-hidden="true"
            />
            <h2 className="advantage__title">{title}</h2>
            {text ? <p className="advantage__text">{text}</p> : null}
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Advantage;
